export default {
  "notifications": {
    "noNotifications": "No notifications yet",
    "markAsRead": "Mark as read",
    "markAllAsRead": "Mark all as read",
    "delete": "Delete",
    "deleteConfirm": "Are you sure you want to delete this notification?",
    "email": "Email",
    "whatsapp": "WhatsApp",
    "type": "Type",
    "subject": "Subject",
    "body": "Message",
    "recipient": "Recipient",
    "status": "Status",
    "sent": "Sent",
    "failed": "Failed",
    "pending": "Pending",
    "createdAt": "Sent at",
    "readAt": "Read at",
    "unreadCount": "Unread notifications",
    "loadingMore": "Loading more notifications...",
    "errorLoading": "Error loading notifications",
    "errorMarkingAsRead": "Error marking notification as read",
    "errorDeleting": "Error deleting notification",
    "successMarkingAsRead": "Notification marked as read",
    "successDeleting": "Notification deleted successfully"
  }
};

